<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
	<div class="flex-header">
		<student-header [showYearSelector]="true" [pageTitle]="'Awards'"></student-header>
	</div>
	<div class="flex-content">
		<div style="text-align:center;width:100%" *ngIf="awards.length == 0 && isBusy==false" translate>No Awards data exists for student.</div>
		<div style="height:100%; overflow:auto;flex-grow:1;" *ngIf="awards.length > 0">
			<mat-table #table [dataSource]="angularMatData" matSort matSortDisableClear id="awardsDataTable" matSortActive="AwardName" aria-label="Awards Data Table" tabindex="0">
				<!-- Individual column definitions -->
				<ng-container matColumnDef="AwardName">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;margin-right:10px;">
						<span translate>Award</span>
						<filter class="mat-filter" [data]="angularMatData" columnName="AwardName" dataType="string"></filter>
					</mat-header-cell>
					<mat-cell *matCellDef="let award" style="min-width:150px;margin-right:10px;">{{award.AwardName}}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="AwardDetails">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;margin-right:10px;">
						<span translate>Details</span>
						<filter class="mat-filter" [data]="angularMatData" columnName="AwardDetails" dataType="string"></filter>
					</mat-header-cell>
					<mat-cell *matCellDef="let award" style="min-width:150px;margin-right:10px;">{{award.AwardDetails}}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="AwardDate">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;margin-right:10px;">
						<span translate>Date</span>
						<filter class="mat-filter" [data]="angularMatData" columnName="AwardDate" dataType="date"></filter>
					</mat-header-cell>
					<mat-cell *matCellDef="let award" style="min-width:100px;margin-right:10px;">{{award.AwardDate | date:'MM/dd/yy'}}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="StaffName">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;margin-right:10px;">
						<span translate>Staff Name</span>
						<filter class="mat-filter" [data]="angularMatData" columnName="StaffName" dataType="string"></filter>
					</mat-header-cell>
					<mat-cell *matCellDef="let award" style="min-width:150px;margin-right:10px;">{{award.StaffName}}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="Comment">
					<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;margin-right:10px;">
						<span translate>Comment</span>
						<filter class="mat-filter" [data]="angularMatData" columnName="Comment" dataType="string"></filter>
					</mat-header-cell>
					<mat-cell *matCellDef="let award" style="min-width:150px;margin-right:10px;">{{award.Comment}}</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="awardsDataHeader"></mat-header-row>
				<!-- Data rows -->
				<mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;"
					id="awardsDataRow{{i}}"
					tabindex="0"
					[attr.aria-label]="getAriaRow(row)"
					style="padding:0;overflow:hidden;border-bottom-width:1px;"
					matRipple>
				</mat-row>
			</mat-table>
		</div>
	</div>
</tyl-kendo-pdf-export>
<div class="flex-footer">

	<!-- Middle -->
	<div class="flex-footer-middle"
		style="align-items: center">
		<filter-notification [filtered]="angularMatData.isFiltered()"
			(clearFilter)="angularMatData.removeAllFilters(); changeDetector.detectChanges();"></filter-notification>
	</div>
</div>
